import React from 'react'
import {
  PlaceCategoryInterface,
  PlaceInterface,
  PlaceItemInterface,
} from '../../../../../common/types/interfaces'
import classes from './Details.module.sass'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../../../store/slices/currentClusterSlice'
import { ClusterTypes } from '../../../../../common/types/enums'

type Props = {
  el?: PlaceInterface
}

export const Details = ({ el }: Props) => {
  const currentCluster = useSelector(selectCurrentCluster)
  const isHotel = currentCluster?.type === ClusterTypes.HOTEL

  if (!el) return null

  return (
    <div className={classes.container}>
      <div className={classes.title}>Детали места</div>
      <div className={classes.section}>
        <div className={classes.sectionTitle}>Основное</div>
        <div className={classes.row}>
          <span className={classes.label}>Название:</span>
          <span className={classes.value}>{el.name}</span>
        </div>
        {el.description && (
          <div className={classes.row}>
            <span className={classes.label}>Описание:</span>
            <span className={classes.value}>{el.description}</span>
          </div>
        )}
        {el.placeNumber && (
          <div className={classes.row}>
            <span className={classes.label}>Номер места:</span>
            <span className={classes.value}>{el.placeNumber}</span>
          </div>
        )}
        <div className={classes.row}>
          <span className={classes.label}>Статус:</span>
          <span className={el.isActive ? classes.active : classes.inactive}>
            {el.isActive ? 'Активно' : 'Не активно'}
          </span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Порядок сортировки:</span>
          <span className={classes.value}>{el.sortOrder}</span>
        </div>
      </div>
      {(el.slotDurationMinutes ||
        el.slotIntervalMinutes ||
        el.breakBetweenSlotsMinutes ||
        el.minBookingDurationMinutes ||
        el.maxBookingDurationMinutes ||
        el.cancellationDeadlineMinutes ||
        (isHotel && (el.checkinTime || el.checkoutTime))) && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Бронирование</div>
          {el.slotDurationMinutes !== undefined && el.slotDurationMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Длительность слота:</span>
              <span className={classes.value}>{el.slotDurationMinutes} мин</span>
            </div>
          )}
          {el.slotIntervalMinutes !== undefined && el.slotIntervalMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Шаг сетки:</span>
              <span className={classes.value}>{el.slotIntervalMinutes} мин</span>
            </div>
          )}
          {el.breakBetweenSlotsMinutes !== undefined && el.breakBetweenSlotsMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Перерыв между слотами:</span>
              <span className={classes.value}>{el.breakBetweenSlotsMinutes} мин</span>
            </div>
          )}
          {el.minBookingDurationMinutes !== undefined && el.minBookingDurationMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Мин. длительность брони:</span>
              <span className={classes.value}>{el.minBookingDurationMinutes} мин</span>
            </div>
          )}
          {el.maxBookingDurationMinutes !== undefined && el.maxBookingDurationMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Макс. длительность брони:</span>
              <span className={classes.value}>{el.maxBookingDurationMinutes} мин</span>
            </div>
          )}
          {el.cancellationDeadlineMinutes !== undefined && el.cancellationDeadlineMinutes !== 0 && (
            <div className={classes.row}>
              <span className={classes.label}>Отмена за:</span>
              <span className={classes.value}>{el.cancellationDeadlineMinutes} мин</span>
            </div>
          )}
          {isHotel && (
            <>
              {el.checkinTime && (
                <div className={classes.row}>
                  <span className={classes.label}>Время заезда:</span>
                  <span className={classes.value}>{el.checkinTime}</span>
                </div>
              )}
              {el.checkoutTime && (
                <div className={classes.row}>
                  <span className={classes.label}>Время выезда:</span>
                  <span className={classes.value}>{el.checkoutTime}</span>
                </div>
              )}
            </>
          )}
        </div>
      )}
      {el?.placeItems && el?.placeItems?.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Товары</div>
          <div className={classes.itemsList}>
            {el.placeItems.map((placeItem: PlaceItemInterface) => (
              <div key={placeItem?.item?.id} className={classes.itemName}>
                {placeItem?.item?.name || `Товар #${placeItem?.item?.id}`}
              </div>
            ))}
          </div>
        </div>
      )}

      {el?.placeCategories && el?.placeCategories?.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Категории</div>
          <div className={classes.itemsList}>
            {el.placeCategories.map((placeCategory: PlaceCategoryInterface) => (
              <div key={placeCategory?.category?.id} className={classes.itemName}>
                {placeCategory?.category?.name || `Категория #${placeCategory?.category?.id}`}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
